import "./tarifsNavSectionTitle.css";

function TarifsNavSectionTitle({ children, first = false, last = false }) {
  return (
    <div
      className="tarifs-details-navbar-section-title"
      style={{
        borderTop: first ? "4px solid #222223" : "2px solid #222223",
        borderBottom: last ? "4px solid #222223" : "2px solid #222223",
      }}
    >
      {children}
    </div>
  );
}

export default TarifsNavSectionTitle;
